import React, { useEffect, useState } from 'react';
import { BRIEF_SECTIONS, sectionOrderFor } from './Section';
import { scrollBehavior } from '../../lib/motion';

const FONT = "font-['Metropolis']";

// Section nav for the brief detail page (restructure §7).
//
// The rail is sticky, but before this it only repeated facts from the body, so
// it wasn't earning the position. Four links that actually move you around a
// long page do.
//
// The ORDER of the links follows the brief's state (§6): on an awarded or
// closed brief the outcome is what you came for, so it leads. The sections
// themselves stay in DOM order — reordering the links is honest (they're a
// menu, and a menu can be ordered by relevance) whereas reordering the page
// with CSS would leave the reading order and the tab order disagreeing.
export default function BriefSectionNav({ status, hasAward, className = '' }) {
  const order = sectionOrderFor(status, hasAward);
  const byId = new Map(BRIEF_SECTIONS.map(s => [s.id, s]));
  const sections = order.map(id => byId.get(id)).filter(Boolean);
  const [active, setActive] = useState(sections[0]?.id || null);

  // Scroll-spy. rootMargin pulls the trigger line to the upper third so a
  // heading counts as current once it reaches reading position, not only when
  // it touches the very top of the viewport.
  useEffect(() => {
    if (typeof IntersectionObserver !== 'function') return undefined;
    const els = BRIEF_SECTIONS.map(s => document.getElementById(s.id)).filter(Boolean);
    if (els.length === 0) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter(e => e.isIntersecting);
        if (visible.length) setActive(visible[0].target.id);
      },
      { rootMargin: '0px 0px -70% 0px', threshold: 0 },
    );
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const jump = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
    setActive(id);
  };

  return (
    <nav aria-label="Brief sections" className={className}>
      {/* Horizontal chips on narrow screens (the rail stacks under the content
          there, so a vertical list would sit below everything it links to);
          a vertical list in the rail from lg up. */}
      <ul className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible">
        {sections.map(s => {
          const isActive = active === s.id;
          return (
            <li key={s.id} className="flex-shrink-0">
              <button
                type="button"
                onClick={() => jump(s.id)}
                aria-current={isActive ? 'true' : undefined}
                className={`${FONT} w-full text-left text-[12px] font-semibold rounded-lg px-3 py-1.5 whitespace-nowrap transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fusion-forest ${
                  isActive
                    ? 'bg-fusion-forest/[0.10] text-fusion-forest'
                    : 'text-[#51534A] hover:text-ink hover:bg-black/[0.03]'
                }`}>
                {s.title}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
